module.exports = {};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_iterators.js
 ** module id = 124
 ** module chunks = 0
 **/